import {Routes} from '@angular/router';
import {SearchRobinsonComponent} from './search/components/search-robinson/search-robinson.component';


export const ROBINSON_ROUTES: Routes = [
    {path: 'robinson/search', component: SearchRobinsonComponent}
];


// WEBPACK FOOTER //
// /var/www/backend/src/app/robinson/robinson.routes.ts